document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-cookie-root]')
  const banner = document.querySelector('[data-cookie-banner]')
  if (!root || !banner) return

  const overlay = root.querySelector('[data-cookie-overlay]')
  const bannerView = banner.querySelector('[data-cookie-banner-view]')
  const preferencesView = banner.querySelector('[data-cookie-preferences-view]')
  const toggles = banner.querySelectorAll('[data-cookie-toggle]:not([disabled])')
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  const REVEAL_DELAY_MS = 3500
  const FADE_MS = 150
  const HIDE_MS = 500

  const defaultPreferences = {
    performance: false,
    functional: false,
    targeting: false,
    necessary: true,
  }

  let collapsedHeight = 0
  let privacy = null

  const loadPrivacyApi = (onReady) => {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      privacy = window.Shopify.customerPrivacy
      onReady()
      return
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error && window.Shopify.customerPrivacy) {
          privacy = window.Shopify.customerPrivacy
        }
        onReady()
      })
      return
    }

    onReady()
  }

  const hasConsent = () => {
    if (localStorage.getItem('cookie-consent')) return true

    if (privacy) {
      const consent = privacy.currentVisitorConsent()
      if (consent && consent.marketing !== '') return true
    }

    return false
  }

  const applyConsent = (states) => {
    localStorage.setItem('cookie-consent', JSON.stringify(states))

    if (!privacy) return

    privacy.setTrackingConsent(
      {
        analytics: states.performance,
        marketing: states.targeting,
        preferences: states.functional,
      },
      () => {},
    )
  }

  const getToggleStates = () => ({
    performance: banner.querySelector('[data-cookie-toggle="performance"]')?.dataset.active === 'true',
    functional: banner.querySelector('[data-cookie-toggle="functional"]')?.dataset.active === 'true',
    targeting: banner.querySelector('[data-cookie-toggle="targeting"]')?.dataset.active === 'true',
    necessary: true,
  })

  const setToggleStates = (states) => {
    toggles.forEach((toggle) => {
      const key = toggle.dataset.cookieToggle
      if (!key || !(key in states)) return

      const active = states[key]
      toggle.dataset.active = active ? 'true' : 'false'
      toggle.setAttribute('aria-checked', active ? 'true' : 'false')
    })
  }

  const revealBanner = () => {
    banner.classList.remove('translate-y-0')
    banner.classList.add('translate-y-full')
    root.hidden = false
    void banner.offsetHeight

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        banner.classList.remove('translate-y-full')
        banner.classList.add('translate-y-0')
      })
    })
  }

  const hideBanner = () => {
    banner.classList.remove('translate-y-0')
    banner.classList.add('translate-y-full')
    overlay.classList.add('opacity-0', 'pointer-events-none')
    overlay.classList.remove('pointer-events-auto')

    window.setTimeout(() => {
      root.hidden = true
    }, HIDE_MS)
  }

  const applyBannerLayout = () => {
    preferencesView.classList.add('hidden')
    preferencesView.classList.remove('flex')
    bannerView.classList.remove('hidden')
    bannerView.classList.add('flex')
  }

  const applyPreferencesLayout = () => {
    bannerView.classList.add('hidden')
    bannerView.classList.remove('flex')
    preferencesView.classList.remove('hidden')
    preferencesView.classList.add('flex')
  }

  const showBannerPanel = () => {
    overlay.classList.add('opacity-0', 'pointer-events-none')
    overlay.classList.remove('pointer-events-auto')

    if (prefersReducedMotion) {
      applyBannerLayout()
      bannerView.style.opacity = ''
      preferencesView.style.opacity = ''
      banner.style.height = ''
      return
    }

    banner.style.height = banner.offsetHeight + 'px'
    void banner.offsetHeight
    preferencesView.style.opacity = '0'

    window.setTimeout(() => {
      applyBannerLayout()
      preferencesView.style.opacity = ''
      bannerView.style.opacity = '0'
      void bannerView.offsetWidth

      banner.style.height = collapsedHeight + 'px'
      bannerView.style.opacity = '1'

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return
        banner.style.height = ''
        banner.removeEventListener('transitionend', onEnd)
      }
      banner.addEventListener('transitionend', onEnd)
    }, FADE_MS)
  }

  const showPreferencesPanel = () => {
    overlay.classList.remove('opacity-0', 'pointer-events-none')
    overlay.classList.add('pointer-events-auto')

    if (prefersReducedMotion) {
      applyPreferencesLayout()
      bannerView.style.opacity = ''
      preferencesView.style.opacity = ''
      banner.style.height = '100svh'
      return
    }

    collapsedHeight = banner.offsetHeight
    banner.style.height = collapsedHeight + 'px'
    bannerView.style.opacity = '0'

    window.setTimeout(() => {
      applyPreferencesLayout()
      bannerView.style.opacity = ''
      preferencesView.style.opacity = '0'
      void preferencesView.offsetWidth

      banner.style.height = '100svh'
      preferencesView.style.opacity = '1'
    }, FADE_MS)
  }

  const acceptAll = () => {
    const states = {
      performance: true,
      functional: true,
      targeting: true,
      necessary: true,
    }
    setToggleStates(states)
    applyConsent(states)
    hideBanner()
  }

  const refuseAll = () => {
    const states = {
      performance: false,
      functional: false,
      targeting: false,
      necessary: true,
    }
    setToggleStates(states)
    applyConsent(states)
    hideBanner()
  }

  const savePreferences = () => {
    applyConsent(getToggleStates())
    hideBanner()
  }

  const bindEvents = () => {
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const active = toggle.dataset.active === 'true'
        toggle.dataset.active = active ? 'false' : 'true'
        toggle.setAttribute('aria-checked', active ? 'false' : 'true')
      })
    })

    banner.querySelector('[data-cookie-accept]')?.addEventListener('click', acceptAll)

    banner.querySelector('[data-cookie-decline]')?.addEventListener('click', refuseAll)

    banner.querySelector('[data-cookie-manage]')?.addEventListener('click', () => {
      const preferencesOpen = !preferencesView.classList.contains('hidden')
      if (preferencesOpen) savePreferences()
      else showPreferencesPanel()
    })

    banner.querySelector('[data-cookie-close]')?.addEventListener('click', refuseAll)

    banner.querySelector('[data-cookie-preferences-close]')?.addEventListener('click', showBannerPanel)

    document.addEventListener('visitorConsentCollected', () => {
      if (!root.hidden) hideBanner()
    })
  }

  loadPrivacyApi(() => {
    if (hasConsent()) return

    setToggleStates(defaultPreferences)
    bindEvents()
    window.setTimeout(revealBanner, REVEAL_DELAY_MS)
  })
})
